import { fetcher } from '@commenda/utils';

/**
 * Assigns (or unassigns) a specific company user to a ServiceRequestTask.
 * Pass `userId = null` to clear the assignment.
 */
export async function setTaskAssignee({
  taskId,
  userId,
}: {
  taskId: number;
  userId: string | null;
}): Promise<void> {
  await fetcher(
    `service-request/task/${taskId}/assignee`,
    {
      method: 'POST',
      body: { userId },
    },
    undefined,
  );
}
